import styled from 'styled-components';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';

export const StyledGrid = styled(Grid)`
  && {
    margin-top: ${spacing(2)};

    ${mediaQuery.tabletLandscape`
      margin-top: ${spacing(3)};
    `}
  }
`;
